import React, { Component } from 'react';
import ArrowIcon from '../../images/arrow.png';
class CompleteItemsOrderQty extends Component {
    constructor(props) {
      super(props);
      console.log("this.props.itemqty",this.props);
    
    }

    render(){
        const itemdata=this.props && this.props.itemdetail && this.props.itemdetail.job_order.order && this.props.itemdetail.job_order.order_items;
        if(this.props && this.props.itemdetail.status == "success"){
          return(
            <div>
                 {itemdata && itemdata.map(order => (

                    <div className="order_info_row">
             
                        <span className="p-2 item_name">{order.name}</span>
                        <span className="px-0 py-2 item_price">{order.price}</span>
                        <span className="px-0 py-2 item_qty">
                        <div className="item_qty_inner">
                        <div className="item_qty_block">
                           {parseInt(order.qty_ordered)}
                         </div>
                        </div>
                        </span>
                <span className="py-2 px-2 item_total_price">{order.row_total}</span>
                </div>
                 ))}
         
          </div>
       );
        }
        else{
return(
  <div>No data</div>
)
        }
    }
  }
  
  export default CompleteItemsOrderQty;



// WEBPACK FOOTER //
// ./src/components/Completed/completeItemOrderQty.js